import Popover from "@material-ui/core/Popover";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import FileTypeButton from "../buttons/FileTypeButton";

const useStyles = makeThemedStyles("Toolbar.ExportDashboardPopUp", (theme) => ({
  root: {},
  paper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    gap: "10px",
    borderRadius: "1em",
    border: "1px solid #fafafa",
    backgroundColor: "#fff",
    color: "rgba(76,81,87, 0.8)",
    fontSize: "1.6em",
    paddingTop: "0.8em",
    paddingBottom: "0.5em",
    textTransform: "uppercase",
    fontWeight: 500,
    minWidth: "170px",
    marginTop: "16px",
    overflowX: "unset",
    overflowY: "unset",
    "&::after": {
      content: '""',
      height: "0px",
      width: "0px",
      position: "absolute",
      left: "calc(50% - 15px)",
      borderRight: "solid 15px transparent",
      borderLeft: "solid 15px transparent",
      borderBottom: "solid 15px white",
      top: "-15px",
    },
  },
}));

interface Props {
  anchorEl: HTMLDivElement | HTMLButtonElement | null;
  onClose: () => void;
  handleClick: (type: string) => void;
  fileTypes?: string[];
}

const ExportFileSelectionPopUp = ({
  onClose,
  anchorEl,
  handleClick,
  fileTypes,
}: Props) => {
  const isOpen = Boolean(anchorEl);
  const classes = useStyles();
  const AVAILABLE_EXPORT_TYPES: string[] = fileTypes || ["pptx", "pdf"];
  return (
    <Popover
      disableScrollLock
      classes={classes}
      id={isOpen ? "export-dashboard-popover" : undefined}
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      {AVAILABLE_EXPORT_TYPES.map((type) => (
        <FileTypeButton handleClick={handleClick} type={type} />
      ))}
    </Popover>
  );
};

export default ExportFileSelectionPopUp;
